module.exports = __webpack_public_path__ + "static/media/employees_items.de5c781c.svg";